<template>
    <div class="nevs-content">
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadRegistrations">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.first_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.last_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.member_id"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.email"></NevsTextField>
                    </td>
                    <td>
                        <NevsSelect v-model="tableData.filters.action" :options="actionOptions"></NevsSelect>
                    </td>
                    <td>
                        <NevsSelect v-model="tableData.filters.success"
                                    :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.device"></NevsTextField>
                    </td>
                    <td></td>
                </tr>
                <tr v-for="(registration, key) in tableData.records" :key="key">
                    <td>{{ registration.first_name }}</td>
                    <td>{{ registration.last_name }}</td>
                    <td>{{ registration.member_id }}</td>
                    <td>{{ registration.email }}</td>
                    <td>{{ actionLabel(registration.action) }}</td>
                    <td>
                        <span :class="registration.success ? 'nuki-result-success' : 'nuki-result-error'">
                            {{ resultLabel(registration.result) }}
                        </span>
                    </td>
                    <td>{{ registration.device }}</td>
                    <td>{{ registration.time_display }}</td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "ModuleNukiRegistrations",
    components: {NevsSelect, NevsTextField, NevsTable, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'first_name',
                        label: this.$LANG.Get('fields.firstName')
                    },
                    {
                        name: 'last_name',
                        label: this.$LANG.Get('fields.lastName')
                    },
                    {
                        name: 'member_id',
                        label: this.$LANG.Get('fields.memberId')
                    },
                    {
                        // The address lives inside the person's emails JSON, so it can be filtered but not
                        // sorted on.
                        name: 'email',
                        label: this.$LANG.Get('fields.email'),
                        sortable: false
                    },
                    {
                        name: 'action',
                        label: this.$LANG.Get('fields.direction')
                    },
                    {
                        name: 'result',
                        label: this.$LANG.Get('fields.result')
                    },
                    {
                        name: 'device_name',
                        label: this.$LANG.Get('fields.mobileDevice')
                    },
                    {
                        name: 'time',
                        label: this.$LANG.Get('fields.time')
                    }
                ],
                filters: {
                    first_name: '',
                    last_name: '',
                    member_id: '',
                    email: '',
                    action: -1,
                    success: -1,
                    device: ''
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'time',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            }
        }
    },
    computed: {
        actionOptions() {
            return [
                {label: this.$LANG.Get('options.all'), value: -1},
                {label: this.$LANG.Get('labels.nukiActionEnter'), value: 'ENTER'},
                {label: this.$LANG.Get('labels.nukiActionExit'), value: 'EXIT'}
            ];
        }
    },
    methods: {
        actionLabel(action) {
            return action === 'EXIT'
                ? this.$LANG.Get('labels.nukiActionExit')
                : this.$LANG.Get('labels.nukiActionEnter');
        },
        // The API stores whatever the endpoint returned, so an unrecognized code is shown as it came rather
        // than swallowed - a result nobody has a translation for is still worth reading.
        resultLabel(result) {
            const known = {
                success: 'labels.nukiResultSuccess',
                entry_not_allowed: 'labels.nukiResultEntryNotAllowed',
                door_not_configured: 'labels.nukiResultDoorNotConfigured',
                door_error: 'labels.nukiResultDoorError',
                resource_does_not_exist: 'labels.nukiResultResourceDoesNotExist'
            };
            return known[result] ? this.$LANG.Get(known[result]) : result;
        },
        reloadRegistrations(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'nuki-registrations', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        if (!this.$store.state.user.permissions.includes('ADMINISTRATOR') || !this.$store.state.user.client.nuki_enabled) {
            this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.unauthorized'), type: 'alert'});
            this.$router.push('/');
            return;
        }
        this.$store.commit('selectMenu', 'settings');
        this.$store.commit('selectSubMenu', 'nukiRegistrations');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.settings'),
                link: null
            },
            {
                label: this.$LANG.Get('modules.nukiRegistrations'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
    unmounted() {
        window.removeEventListener('resize', this.resolveWindowResize);
    }
}
</script>

<style scoped>
.nuki-result-error {
    color: #c0392b;
}

.nuki-result-success {
    color: #27ae60;
}
</style>
